export default {"src":"https://fishbrain.com/_next/static/media/texas.f93f5e52.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};